jQuery(function () {
$(document).ready(function () {
    $(".inContentManual--SingleCard").click(function (e) {
        e.preventDefault();
        var $target = $(this);
        var promoHeading = $target.find('.ImageAboveContent--Content h3').text().trim() || 'Default Promo Name';
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            "event": "ga4_select_promotion",
            "ga4_data": {
                "creative_name": "Article box",
                "promotion_name": promoHeading
            }
        });
        setTimeout(function () {
            window.location = $target.find("a").attr("href");
        }, 200);
        return false;
    });
});
});